import { useState, useEffect } from 'react';

/**
 * usePageVisibility
 * 
 * Returns a boolean indicating whether the browser tab is currently visible.
 * Components with setInterval/setTimeout-based animations should use this to
 * pause their timers when the tab is hidden and restart cleanly on return.
 * 
 * This prevents the well-known browser behavior where throttled background-tab
 * timers queue up and fire in rapid succession when the tab regains focus,
 * causing animations to jump, desync, or go haywire.
 */
export default function usePageVisibility() {
  const [isPageVisible, setIsPageVisible] = useState(
    () => document.visibilityState === 'visible'
  );

  useEffect(() => {
    const handler = () => setIsPageVisible(document.visibilityState === 'visible');
    document.addEventListener('visibilitychange', handler);
    return () => document.removeEventListener('visibilitychange', handler);
  }, []);

  return isPageVisible;
}
